<template>
  <b-col>
    <b-card
      v-if="!id"
      sub-title="Moje zápisníčky, krabičky a obrázky"
      header="DARČEKY"
      text-variant="dark"
    >
      <b-row>
        <b-col
          v-for="(item, index) in data"
          :key="index"
          deck
          sm="12"
          md="6"
          lg="4"
          style="margin-top:5px"
        >
          <postcard
            :source-pictutes="data[index].pictutes"
            :title-img="data[index].title"
            :details-img="data[index].details"
            :size-img="data[index].size"
            :material-img="data[index].material"
            :kind-img="data[index].img"
            :path-img="/darceky/ + data[index].id"
          />
        </b-col>
      </b-row>
    </b-card>
    <router-view/>
  </b-col>
</template>

<script>
import Picture from "./Picture"
import { ref, watch } from "@vue/composition-api"
export default {
  name: 'Darceky',
  components: {
    'postcard': Picture
  },
  setup(params, context) {
    const id = ref(false)
    if (context.root.$route.params.id) {
      id.value = true
    }
    watch(() => context.root.$route.params.id, (value) => { value ? id.value = true : id.value = false })
    const data = ref([
      {
        pictutes: ['/static/images/darceky/darceky1.jpg','/static/images/darceky/darceky2.jpg','/static/images/darceky/darceky3.jpg','/static/images/darceky/darceky4.jpg'],
        title: "V brezovom hájičku... - 5,40 €",
        subtitle: "Zápisník",
        details: "...malý zápisníček dekorovaný technikou decoupage z oboch vonkajších strán, prelakovaný (fotené pred lakovaním). Vnútro obsahuje 60 čistých listov, na voľno previazaný bielym špagátikom.",
        size: "...rozmery 15,5 x 11 cm",
        material: "obyčajný papier, špagát, kartón",
        kind: "decoupage, lepenie",
        id: 7
      },
      {
        pictutes: ['/static/images/darceky/darceky5.jpg','/static/images/darceky/darceky6.jpg','/static/images/darceky/darceky7.jpg','/static/images/darceky/darceky8.jpg'],
        title: "Červená lentilka - 6,30 €",
        subtitle: "Krabička",
        details: "...spomínam, keď sme dostali lentilky a červené sme troška namočili, pustili farbu a my sme si nimi rúžovali pery :) bodky na krabičke sú ako tie namočené lentilky postupne strácajúce farbu... ...malinká bodkovaná krabička nielen na lentilky, je zdobená technikou decoupage, prelakovaná ekolakom a previazaná, vnútro je bez zásahov, v surovom stave, spodok je dekorovaný. Krabička má vrchnák, bez kovania.",
        size: "...cca 12 x 8 x 6,5 cm",
        material: "iné mäkké drevo",
        kind: "decoupage",
        id: 6
      },
      {
        pictutes: ['/static/images/darceky/darceky9.jpg','/static/images/darceky/darceky10.jpg','/static/images/darceky/darceky11.jpg','/static/images/darceky/darceky12.jpg'],
        title: "Uži si každý okamih - 5,40 €",
        subtitle: "Obrázok",
        details: "...obrázok s motivačným nápisom - Tešiť sa z malých vecí :) Rámik je polotovar a samotný obrázok v okrúhlom tvare, je vyrobený technikou decoupage, ručne vyrezaný a nalepený na pevný biely fotokartón. Motív má iný odtieň bielej farby ako podklad, nesplýva s ním.",
        size: "...18 x 13 cm",
        material: "kartón, obyčajný papier",
        kind: "decoupage, lepenie",
        id: 5
      },
      {
        pictutes: ['/static/images/darceky/darceky13.jpg','/static/images/darceky/darceky14.jpg','/static/images/darceky/darceky15.jpg'],
        title: "Hviezdná obloha - 5,40 €",
        subtitle: "Krabička",
        details: "...krásne zasnená malinká krabička s nočnou oblohou plnou hviezd, bola vyrobená technikou decoupage, zdobený je len vrchnáčik, inak je bielej farby a vnútro je nezdobené. Krabička je previazaná bielym motúzikom. Zalakovaná nezávadným ekolakom. Môže byť dekoráciou detskej izbičky, vianočnou dekoráciou alebo na ukrytie malých tajomstiev ;) Farba krabičky je skôr tmavomodrá, na slnku s tyrkysovým nádychom, nepodarilo sa mi to hodnoverne zachytiť fotkou, ale je trocha svetlejšia ako na fotkách.",
        size: "vrchnáčik cca 10 x 10 cm, spodná časť cca 8,5 x 8,5 cm",
        material: "iné mäkké drevo, špagát",
        kind: "decoupage",
        id: 4
      },
      {
        pictutes: ['/static/images/darceky/darceky16.jpg','/static/images/darceky/darceky18.jpg','/static/images/darceky/darceky17.jpg','/static/images/darceky/darceky18.jpg'],
        title: "Nekonečná láska - 9,90 €",
        subtitle: "Zápisník",
        details: "...zápisník alebo album pre najkrajšie chvíle v živote ženy :) ...zdobený motívom budúcej mamičky, ten bol vytvorený technikou decoupage, ručne vyrezaný a nalepený v 3D efekte. Predná a zadná strana sú z tvrdej lepenky a vrchné béžové papiere sú archivačnej hodnoty. Prizdobený výrezom z lepenky - Nekonečná láska - . Obsahuje 20 vnútorných listov, sú bielej farby, inak nezdobené.",
        size: "15,2 x 15,2 cm",
        material: "archivačný papier, kartón, špagát, obyčajný papier",
        kind: "decoupage, lepenie, cardmaking",
        id: 3
      },
      {
        pictutes: ['/static/images/darceky/darceky19.jpg','/static/images/darceky/darceky20.jpg','/static/images/darceky/darceky21.jpg','/static/images/darceky/darceky22.jpg','/static/images/darceky/darceky23.jpg'],
        title: "Keď cválajú... - 5,40 €",
        subtitle: "Zápisník",
        details: "...cítia sa slobodne. ...zápisník vyzdobený technikou decoupage. Veľmi príjemný na dotyk, akoby ste hladkali koníka :) Vnútro surové, bez zdobenia. Zápisník je polotovar, nie je ručne robený, vnútri 60 bielych listov.",
        size: "...cca 15,5 x 11 cm",
        material: "obyčajný papier, kartón, špagát",
        kind: "decoupage, lepenie",
        id: 2
      },
      {
        pictutes: ['/static/images/darceky/darceky24.jpg','/static/images/darceky/darceky25.jpg','/static/images/darceky/darceky26.jpg'],
        title: "Sloboda - 5,40 €",
        subtitle: "Zápisník",
        details: "...pre dobrodruha, ktorý má hlavu stále v oblakoch, na spomienky, plány, myšlienky :) ...zápisník vyzdobený technikou decoupage (len vrchná strana), prelakovaný lakom na decoupage. Na vnútornej  prednej strane je záložka na zakladanie lístkov, ústrižkov... .Zápisník je polotovar, nie je ručne robený, vnútri 60 bielych listov.",
        size: "...cca 15,5 x 11 cm",
        material: "obyčajný papier, kartón",
        kind: "decoupage, lepenie",
        id: 1
      }
    ])
    return {
      data,
      id
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Darceky.vue